import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      <section className="banner-section ">
        <img
          src="/images/about-banner.jpg"
          className="banner-img"
          alt="Banner Image"
        />
        <div className="container">
          <div className="banner-contant">
            <h1>Privacy policy</h1>
            <p class="mb-0">
              Welcome to Modular kitchen – Jaipur’s premier destination for
              innovative, stylish, and functional modular kitchens. We are
              passionate about creating kitchens that go beyond the ordinary,
              combining cutting-edge designs with high-quality materials to
              build spaces where functionality meets elegance.
            </p>
          </div>
        </div>
      </section>
      <section className="seoText">
        <div className="container">
          <p>
            Welcome to Modular Kitchen Jaipur! Your privacy is of utmost
            importance to us, and we are committed to protecting the personal
            information you share with us. This Privacy Policy outlines how we
            collect, use, and safeguard your data when you visit our website or
            engage with our services.
          </p>
          <h3>1. Information We Collect</h3>
          <p>We may collect the following types of information:</p>
          <p>
            Personal Information: Name, email address, phone number, and any
            details you provide via forms or inquiries.
          </p>
          <p>
            Non-Personal Information: Browser type, IP address, device
            information, and website usage data collected through cookies and
            similar technologies.
          </p>
          <h3>2. How We Use Your Information</h3>
          <p>We use your information for the following purposes:</p>
          <p>To respond to inquiries or requests.</p>
          <p>To improve our website and services.</p>
          <p>
            To provide updates, promotions, and marketing communications (with
            your consent).
          </p>
          <p>To comply with legal obligations.</p>
          <h3>3. Cookies and Tracking Technologies</h3>
          <p>
            Our website uses cookies to enhance user experience and analyze site
            performance. You can manage or disable cookies through your browser
            settings.
          </p>
          <h3>4. Information Sharing</h3>
          <p>
            We do not sell, trade, or rent your personal information to third
            parties. However, we may share data with trusted service providers
            or partners to facilitate our services, under strict confidentiality
            agreements.
          </p>
          <h3>5. Data Security</h3>
          <p>
            We take reasonable measures to protect your information from
            unauthorized access, alteration, or disclosure. However, no online
            system can be 100% secure.
          </p>
          <h3>6. Third-Party Links</h3>
          <p>
            Our website may include links to third-party websites. We are not
            responsible for their privacy practices or content. Please review
            their policies before providing any personal information.
          </p>
          <h3>7. Your Rights</h3>
          <p>You have the right to:</p>
          <p>Access, update, or delete your personal information.</p>
          <p>Opt out of receiving marketing communications.</p>
          <p>Withdraw consent for data collection where applicable.</p>
          <p>
            To exercise these rights, contact us at
            sales.modularkitchens@gmail.com .
          </p>
          <h3>8. Changes to This Policy</h3>
          <p>
            We reserve the right to update this Privacy Policy at any time.
            Changes will be posted on this page with the effective date. Please
            review it periodically.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
